/* Shared helper for .gg-shelf scrollers (see gg-shelf.css). */
window.ggShelf = window.ggShelf || {
  /**
   * Shows only the cells for which keep(li) is true (up to the list's data-limit) and
   * scrolls back to the start. keep is called for every cell, even past the limit.
   * @param {HTMLElement} list - The ul.gg-shelf.
   * @param {Function} keep - Predicate called with each li.
   * @returns {number} How many cells are visible.
   */
  filter(list, keep) {
    const limit = Number(list.dataset.limit) || Infinity;
    let visible = 0;
    Array.from(list.children).forEach((li) => {
      const show = Boolean(keep(li)) && visible < limit;
      li.hidden = !show;
      if (show) visible += 1;
    });
    list.scrollLeft = 0;
    const scroller = list.closest('gg-shelf-scroller');
    if (scroller && scroller.update) scroller.update();
    return visible;
  }
};

/* Desktop prev/next arrows: scroll one page of cards, disabled at each end. */
if (!customElements.get('gg-shelf-scroller')) {
  customElements.define('gg-shelf-scroller', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.gg-shelf');
      this.prev = this.querySelector('.gg-shelf-arrow--prev');
      this.next = this.querySelector('.gg-shelf-arrow--next');
      if (!this.list || !this.prev || !this.next) return;

      this.update = this.update.bind(this);
      this.prev.addEventListener('click', () => this.page(-1));
      this.next.addEventListener('click', () => this.page(1));
      this.list.addEventListener('scroll', this.update, { passive: true });
      // Fires when the list resizes or a hidden tab panel is shown.
      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.list);
      this.update();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    page(dir) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.list.scrollBy({ left: dir * this.list.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
    }

    update() {
      if (!this.list) return;
      const { scrollLeft, clientWidth, scrollWidth } = this.list;
      this.toggleAttribute('data-fits', scrollWidth <= clientWidth + 1);
      this.prev.disabled = scrollLeft <= 1;
      this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 1;
    }
  });
}
